import styled from "styled-components";
export const UserDataContainer = styled.div`
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.19);
  overflow: hidden;
  padding: 32px;
  margin: 16px 0;
  position: relative;
  .edit-icon {
    font-size: 24px;
    position: absolute;
    top: 16px;
    left: 16px;
    cursor: pointer;
    color: #222;
  }
  .item {
    span {
      display: block;
      &:first-child {
        color: ${({ theme }) => theme.colors.lightFont};
        font-size: ${({ theme }) => theme.sizes.fontsm};
      }
      &:last-child {
        color: ${({ theme }) => theme.colors.font};
        font-size: ${({ theme }) => theme.sizes.font};
        font-weight: bold;
      }
    }
  }
`;
